<mobile-page-content [fullPageWidth]="true" class="page-content">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <ng-container *ngIf="is404">
        <div fxLayout="column" fxLayoutAlign="center center" style="height: 100%">
            <div>
                {{ 'Session_no_longer_exists' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!is404">
        <sessions-session-view *ngIf="!is404"
                               [organization]="organization"
                               [session]="session"
                               [isEditable]="false"
                               [showLeftPanel]="false"
                               [isMobileDisplay]="true"
        >

        </sessions-session-view>
    </ng-container>
</mobile-page-content>
